import { updateFaqEntryFeedbackArgsToParams } from 'data/api/transformers/arguments/update-faq-entry-feedback-args-to-params'
import { UpdateFaqEntryFeedbackArgs } from 'types/api/arguments/update-faq-entry-feedback-args'

import { api } from './api'

export const updateFaqEntryFeedbackForm = (args: UpdateFaqEntryFeedbackArgs) =>
  api.patch(`/faq_entries/${args.faqId}/feedback`, updateFaqEntryFeedbackArgsToParams(args))
